<cs-header>
  <cs-header-title>Nutrient List Tests</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <!-- Configuration Card -->
    <cs-card>
      <cs-card-header>Nutrient Configuration</cs-card-header>
      <cs-card-content>
        <div class="nutrient-grid" style="display: grid; grid-template-columns: auto 1fr 1fr; gap: 12px; align-items: center;">
          <div class="nutrient-grid__header"></div>
          <div class="nutrient-grid__header">Value</div>
          <div class="nutrient-grid__header">Target</div>

          <cs-label>Calories</cs-label>
          <cs-input-measure type="nutrient_kcal" [(canonValue)]="calories" (canonValueChange)="onInputChange()"></cs-input-measure>
          <cs-input-measure type="nutrient_kcal" [(canonValue)]="caloriesTarget" (canonValueChange)="onInputChange()"></cs-input-measure>

          <cs-label>Protein</cs-label>
          <cs-input-measure type="nutrient_g" [(canonValue)]="protein" (canonValueChange)="onInputChange()"></cs-input-measure>
          <cs-input-measure type="nutrient_g" [(canonValue)]="proteinTarget" (canonValueChange)="onInputChange()"></cs-input-measure>

          <cs-label>Carbs</cs-label>
          <cs-input-measure type="nutrient_g" [(canonValue)]="carbs" (canonValueChange)="onInputChange()"></cs-input-measure>
          <cs-input-measure type="nutrient_g" [(canonValue)]="carbsTarget" (canonValueChange)="onInputChange()"></cs-input-measure>

          <cs-label>Fat</cs-label>
          <cs-input-measure type="nutrient_g" [(canonValue)]="fat" (canonValueChange)="onInputChange()"></cs-input-measure>
          <cs-input-measure type="nutrient_g" [(canonValue)]="fatTarget" (canonValueChange)="onInputChange()"></cs-input-measure>

          <cs-label>Fiber</cs-label>
          <cs-input-measure type="nutrient_g" [(canonValue)]="fiber" (canonValueChange)="onInputChange()"></cs-input-measure>
          <cs-input-measure type="nutrient_g" [(canonValue)]="fiberTarget" (canonValueChange)="onInputChange()"></cs-input-measure>

          <cs-label>Cholesterol</cs-label>
          <cs-input-measure type="nutrient_mg" [(canonValue)]="cholesterol" (canonValueChange)="onInputChange()"></cs-input-measure>
          <cs-input-measure type="nutrient_mg" [(canonValue)]="cholesterolTarget" (canonValueChange)="onInputChange()"></cs-input-measure>
        </div>
      </cs-card-content>
    </cs-card>

    <!-- Nutrient List States -->
    @for (state of allStates; track state) {
      <cs-card>
        <cs-card-header>State: {{ state }}</cs-card-header>
        <cs-card-content>
          <nutrient-list [nutrients]="displayNutrients" [state]="state" [expandable]="true"
            [attr.data-test]="'nutrient-list-' + state">
          </nutrient-list>
        </cs-card-content>
      </cs-card>
    }
  </cs-card-list>
</cs-content>
